import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CheckboxModule } from 'app/private/_core/_components/_checkbox/checkbox.module';

// Directives
import { ElHeightBottomDirective } from './_directives/el-height-bottom.directive';
import { SVGPathColorDirective } from './_directives/svg-path-color.directive';
import { SVGStrokeColorDirective } from './_directives/svg-stroke-color.directive';
import { TeleportToDirective } from './_directives/teleport-to.directive';
import { TooltipDirective } from './_directives/tooltip.directive';
import { ConfirmInputValidatorDirective } from './_validators/confirm-input-validator.directive';
import { DifferentPasswordValidatorDirective } from './_validators/different-password-validator.directive';
import { ResizeWatcherDirective } from './_directives/resize-watcher.directive';
import { PermanentScrollbarDirective } from 'app/public/_core/_directives/permanent-scrollbar.directive';


// Pipes
import { BoldPredictiveTextPipe } from './_pipes/boldPredictiveText.pipe';
import { DataTestScreenTypePipe } from './_pipes/data-test-screen-type.pipe';
import { DatezonePipe } from './_pipes/datezone.pipe';
import { DurationPipe } from './_pipes/duration.pipe';
import { FeaturedLabelPipe } from './_pipes/featured-label.pipe';
import { HighlightTextPipe } from "./_pipes/highlightText.pipe";
import { ReplaceTextPipe } from './_pipes/replace-text.pipe';
import { SafePipe } from './_pipes/safe.pipe';
import { SafeHtmlPipe } from './_pipes/safeHtml.pipe';
import { TaggedPipe } from './_pipes/tagged.pipe';
import { TruncateTextLengthPipe } from './_pipes/text-truncate.pipe';
import { TimezonePipe } from './_pipes/timezone.pipe';

// Components
import { BasicButtonComponent } from 'app/shared/_components/basic-button/basic-button.component';
import { SliderToggleComponent } from 'app/shared/_components/slider-toggle/slider-toggle.component';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		AngularSvgIconModule,
		CheckboxModule,
		BasicButtonComponent,
		SliderToggleComponent
	],
	declarations: [
		SVGPathColorDirective,
		SVGStrokeColorDirective,
		TooltipDirective,
		ElHeightBottomDirective,
		TeleportToDirective,
		DatezonePipe,
		FeaturedLabelPipe,
		HighlightTextPipe,
		ReplaceTextPipe,
		SafeHtmlPipe,
		SafePipe,
		TimezonePipe,
		TruncateTextLengthPipe,
		TaggedPipe,
		BoldPredictiveTextPipe,
		DurationPipe,
		DataTestScreenTypePipe,
		ConfirmInputValidatorDirective,
		DifferentPasswordValidatorDirective,
		ResizeWatcherDirective,
		PermanentScrollbarDirective
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CheckboxModule,
		SVGPathColorDirective,
		SVGStrokeColorDirective,
		AngularSvgIconModule,
		TooltipDirective,
		ElHeightBottomDirective,
		TeleportToDirective,
		DatezonePipe,
		FeaturedLabelPipe,
		HighlightTextPipe,
		ReplaceTextPipe,
		SafeHtmlPipe,
		SafePipe,
		TimezonePipe,
		TruncateTextLengthPipe,
		TaggedPipe,
		BoldPredictiveTextPipe,
		DurationPipe,
		DataTestScreenTypePipe,
		BasicButtonComponent,
		SliderToggleComponent,
		ConfirmInputValidatorDirective,
		DifferentPasswordValidatorDirective,
		ResizeWatcherDirective,
		PermanentScrollbarDirective
	],
	providers: [
		TaggedPipe,
	]
})
export class SharedModule {}
